import React, { useEffect, useState } from 'react'
import { GetById_ByFoodsAndParking_Reserve_Api, GetById_Reserve_Api, GetReserveDays_Reserve_Api } from '../../API/ReserveApi';
import { Button, Col, Row, Steps ,message, Card, Alert,Typography,Space } from 'antd';
import { ReserveInfoComponent } from '../Reserve/ReserveInfoComponent';
import { ReservePlaceAndTimeComponent } from '../Reserve/ReservePlaceAndTimeComponent';
import { CloseOutlined, DeleteOutlined, DoubleLeftOutlined, DoubleRightOutlined, EditOutlined, PlusOutlined, RollbackOutlined } from '@ant-design/icons';
import { ADayFoodsComponent } from './ADayFoodsComponent';
import { ParkingReserveComponent } from './ParkingReserveComponent';
import { AReserveFoodsAndParking_Step2_Component } from './AReserveFoodsAndParking_Step2_Component';
import { DaysFoodsComponent } from './DaysFoodsComponent';
import { UserOutlined, CalendarOutlined } from '@ant-design/icons'

export const AReserveFoodsAndParking_Step1_Component = ({
    setLoading,
    showMessage,
    reserveId,
    onBackClick,
    onPayCompleted,
}) => {
    // ====================================================================== 
    const { Text } = Typography;
    const [reserve, setReserve] = useState();
    const [days, setDays] = useState([]);
    const [view, setView] = useState('selectCount');
    // ======================================================================
    useEffect(() => {
        loadReserve();
    }, []);
    // ======================================================================    
    const loadReserve = async () => {
        setLoading(true);
        try {
            const data = await GetById_Reserve_Api(reserveId);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setReserve(data.messageData.data);
            }

            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // تابع برای دریافت متن وضعیت
    const getStatusText = (status) => {
        switch (status) {
            case 'None':
                return 'بدون وضعیت';
            case 'Selecting':
                return 'در حال انتخاب';
            case 'Payed':
                return 'پرداخت شده';
            case 'Completed':
                return 'قطعی شده';
            case 'RejectByAdmin':
                return 'رد شده توسط ادمین';
            default:
                return 'نامشخص';
        }
    };

    // تابع برای دریافت رنگ وضعیت
    const getStatusColor = (status) => {
        switch (status) {
            case 'Selecting':
                return '#faad14'; // نارنجی
            case 'Payed':
                return '#52c41a'; // سبز
            case 'Completed':
                return '#1890ff'; // آبی
            case 'RejectByAdmin':
                return '#ff4d4f'; // قرمز
            case 'None':
            default:
                return '#8c8c8c'; // خاکستری
        }
    };

    const isFoodReserveAllowed = () => {
    if (!reserve?.from) return false;
// console.log(reserve.from);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const fromDate = new Date(reserve.from);
    fromDate.setHours(0, 0, 0, 0);

    const startDate = new Date(fromDate);
    startDate.setDate(startDate.getDate() - 7);

    const endDate = new Date(fromDate);
    endDate.setDate(endDate.getDate() + 10);

    return today >= startDate && today <= endDate;
};

    // ======================================================================  
    return (
        <>
            {reserve ?
                <>
                    
                    {view == 'selectCount' ? <>
                        <Row className='sectionTitle' style={{ marginBottom: '10px' }}>
                            <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
                                <Button
                                    className='step-prev-btn btn-light'

                                    onClick={() => { onBackClick() }}
                                >
                                    <DoubleRightOutlined />
                                    <span className='step-prev-btn-title'>
                                        بازگشت
                                    </span>
                                </Button>

                            </Col>
                            <Col xs={10} sm={10} md={10} lg={16} xl={16}>
                                <h2>
                                    رزرو {reserve.period.enableFoodReserve ? "غذا" : <></>}

                                    {reserve.period.enableParkingReserve ? "/پارکینگ" : <></>}
                              </h2>
                              {/* نمایش وضعیت */}
                                    {reserve?.foodAndParkingStatus && reserve.foodAndParkingStatus !== 'None' && (
                                        <span 
                                            style={{
                                                backgroundColor: getStatusColor(reserve.foodAndParkingStatus),
                                                color: 'white',
                                                padding: '4px 12px',
                                                borderRadius: '16px',
                                                fontSize: '14px',
                                                fontWeight: 'bold',
                                                marginRight: '10px'
                                            }}
                                        >
                                            {getStatusText(reserve.foodAndParkingStatus)}
                                        </span>
                                    )}
                            </Col>
                            <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "left" }} >
                                <Button
                                    className={'step-next-btn btn-primary'}
                                    // disabled={!isFoodReserveAllowed()}
                                    onClick={() => {
        if (!isFoodReserveAllowed()) {
            message.warning("زمان مجاز رزرو غذا/پارکینگ 7 روز قبل از شروع اقامت تا 2 روز قبل از شروع اقامت می باشد.");
            return;
        }

        setView("showFactor");
    }}
                                >
                                    <span className='step-next-btn-title'>
                                        تایید و ادامه
                                    </span>
                                    <DoubleLeftOutlined />
                                </Button>
                            </Col>
                        </Row>

                        <div className="no-print">
                                        <ReserveInfoComponent adminMode={false} setLoading={setLoading} showMessage={showMessage} reserve={reserve} showTitle={false} />
                                        <ReservePlaceAndTimeComponent setLoading={setLoading} showMessage={showMessage} reserve={reserve} showTitle={false} />
                                    </div>

                        {reserve.period.enableParkingReserve ? <>


                            <div className='container'>
                                <ParkingReserveComponent
                                    setLoading={setLoading}
                                    showMessage={showMessage}
                                    reserve={reserve}
                                />
                            </div>
                        </> : <></>}

                        {reserve.period.enableFoodReserve ?
                            <DaysFoodsComponent
                                setLoading={setLoading}
                                showMessage={showMessage}
                                reserve={reserve}
                            />
                            : <></>
                        }
                    </> : <></>}
                    {view == 'showFactor' ?
                        <>
                            <AReserveFoodsAndParking_Step2_Component
                                setLoading={setLoading}
                                showMessage={showMessage}
                                reserveId={reserveId}
                                onBackClick={() => { setView('selectCount') }}
                                onPayCompleted={onPayCompleted}
                            />
                        </> : <></>
                    }
                </> : <></>}


        </>

    )
}
